export const Price3DigitSplitter = (PriceNumber) => {
  const splittedNumber = PriceNumber?.toString()?.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );
  return splittedNumber;
};
